import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Index from '../components/common/orders/Index'
import OrdersContainer from '../components/common/orders/OrdersContainer'
import OrderPaymentOptions from '../components/common/orders/OrderPaymentOptions/OrderPaymentOptions'
import PaymentSuccess from '../components/common/credit/PaymentSuccess/PaymentSuccess'
import ServiceStudentsSelectorContainer from '../components/common/Services/ServiceStudentsSelector/ServiceStudentsSelectorContainer'

export const ordersRoutes = (
  <Route path="orders" component={OrdersContainer}>
    <IndexRoute component={Index} />
    <Route path=":orderId/select-students" component={ServiceStudentsSelectorContainer} />
    <Route path=":orderId/payment-options" component={OrderPaymentOptions} />
    <Route path=":orderId/payment-success" component={PaymentSuccess} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/ordersRoutes.js